export default class Base {
  constructor(name, Vue, store) {
    this.name = name
    this.vm = Vue
    this.store = store
  }

  match(middlewareNames) {
    return ~middlewareNames.indexOf(this.name)
  }

  after(to, from) {}

  exec(to, from) {
    if (this.match(_.has(to.meta, "middleware.after") ? to.meta.middleware.after : [])) {
      console.log("after match")
      this.after(to, from)
    } else {
      console.log("after non run")
    }
  }
}
